import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function UnlockedIcon(props) {
  return (
    <SvgIcon viewBox="0 0 21 21" title="Unlocked" {...props}>
      <path
        d="M15.312 1.313c2.415 0 4.375 1.96 4.375 4.375h-1.75c0-1.453-1.173-2.625-2.625-2.625-1.453 0-2.625 1.172-2.625 2.624v1.75h.876c.962 0 1.75.788 1.75 1.75v8.75c0 .963-.788 1.75-1.75 1.75h-10.5c-.963 0-1.75-.787-1.75-1.75v-8.75c0-.962.787-1.75 1.75-1.75h7.874v-1.75c0-2.415 1.96-4.375 4.375-4.375zm-1.75 7.875h-10.5v8.75h10.5v-8.75zm-5.25 2.624c.963 0 1.75.788 1.75 1.75 0 .963-.787 1.75-1.75 1.75-.962 0-1.75-.787-1.75-1.75 0-.962.788-1.75 1.75-1.75z"
        transform="translate(-16.000000, -323.000000) translate(0.000000, 323.000000) translate(16.000000, 0.000000)"
      />
    </SvgIcon>
  );
}

export default UnlockedIcon;
